import type { ZeytalCLIPureConfig } from "@zeytal/kit";
import type { FigmaRestApi } from "@zeytal/types";

export const createBlur = (
  stylesFormatsConfig: ZeytalCLIPureConfig["styles"]["formats"],
  effect: FigmaRestApi.BlurEffect,
) => {
  return `blur(${effect.radius}px)`;
};
